export const INT32_MIN = -2147483648;
export const INT32_MAX = 2147483647;

export const UI_ACTIVE_DIRECTORY_DOMAIN_MAX_LENGTH = 32;

export const UI_COMMENT_MAX_LENGTH = 500;

export const UI_URL_MAX_LENGTH = 2000;
export const UI_MARKUP_MAX_LENGTH = 20000;

export const UI_NUGET_API_KEY_MAX_LENGTH = 128;

export const UI_TITLE_MAX_LENGTH = 32;

export const UI_MACHINE_NAME_MAX_LENGTH = 50;

export const UI_USERNAME_MAX_LENGTH = 32;
export const UI_PASSWORD_MAX_LENGTH = 32;
export const UI_NAME_MAX_LENGTH = 32;
export const UI_NAME_LONG_MAX_LENGTH = 64;
export const UI_AD_SEARCH_REGEX = /^[^,+"<>;\/\\]+$/;

export const UI_NAME_MLPACKAGE_MAX_LENGTH = 128;
export const UI_MLPACKAGE_NAME_REGEX = '^[a-zA-Z][a-zA-Z0-9_]*$';

export const UI_ROBOT_NAME_MAX_LENGTH = 19;
export const UI_ROBOT_USERNAME_MAX_LENGTH = 100;
export const UI_ROBOT_USERNAME_REGEX = /[^\\]+\\[^\\]+/;
export const UI_ROBOT_PASSWORD_MAX_LENGTH = 100;
export const UI_ROBOT_DESCRIPTION_MAX_LENGTH = 500;

export const UI_DESCRIPTION_SHORT_MAX_LENGTH = 250;
export const UI_DESCRIPTION_MAX_LENGTH = 500;

export const UI_ASSET_NAME_MAX_LENGTH = 256;
export const UI_ASSET_DESCRIPTION_MAX_LENGTH = 250;
export const UI_ASSET_PASSWORD_MAX_LENGTH = 256;
export const UI_ASSET_USERNAME_MAX_LENGTH = 512;
export const UI_ASSET_TEXT_MAX_LENGTH = 1000000;

export const UI_SMTP_PASSWORD_MAX_LENGTH = 1200;

export const UI_QUEUE_SCHEMA_MAX_FILE_SIZE = 256000;

export const UI_EMAIL_MAX_LENGTH = 254;
export const UI_EMAIL_DOMAIN_MAX_LENGTH = 189;
export const UI_EMAIL_HOST_MAX_LENGTH =
    UI_EMAIL_MAX_LENGTH -
    UI_EMAIL_DOMAIN_MAX_LENGTH -
    2;

export const UI_MAX_LOCKOUT_SECONDS = 60 * 60 * 24 * 30; /* 1 month in seconds */

export const UI_TASK_CATALOG_DESCRIPTION_MAX_LENGTH = 512;
export const UI_TASK_CATALOG_NAME_MAX_LENGTH = 50;

export const UI_QUEUE_ITEM_REFERENCE_MAX_LENGTH = 128;

export const CREDENTIAL_STORES_NAME_MAX_LENGTH = 50;

export const WEBHOOKS_SECRET_MAX_LENGTH = 100;

export const UI_CALENDAR_NAME_MAX_LENGTH = 150;
